import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  doc,
  getDoc,
  updateDoc,
  Timestamp,
  collection,
  query,
  where,
  getDocs,
  addDoc,
  serverTimestamp
} from "firebase/firestore";
import { db } from "../../Firebase";
import AdminNav from "../../components/AdminNav";

export default function AdminLeadDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [lead, setLead] = useState(null);
  const [status, setStatus] = useState("");
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);
  const [inspectionDate, setInspectionDate] = useState("");
  const [reportId, setReportId] = useState(null);
  const [checkingReport, setCheckingReport] = useState(true);

  useEffect(() => {
    const fetchLeadAndReport = async () => {
      // Fetch lead
      const snap = await getDoc(doc(db, "leads", id));
      if (!snap.exists()) return navigate("/admin/leads");

      const data = snap.data();
      setLead(data);
      setStatus(data.status);
      setNotes(data.notes || "");

      if (data.inspectionDate) {
        setInspectionDate(
          data.inspectionDate.toDate().toISOString().split("T")[0]
        );
      }

      // Check for existing inspection report
      const reportQuery = query(
        collection(db, "inspectionReports"),
        where("leadId", "==", id)
      );

      const reportSnap = await getDocs(reportQuery);
      if (!reportSnap.empty) {
        setReportId(reportSnap.docs[0].id);
      }

      setCheckingReport(false);
    };

    fetchLeadAndReport();
  }, [id, navigate]);

  const saveChanges = async () => {
    setSaving(true);
    await updateDoc(doc(db, "leads", id), {
      status,
      notes,
      inspectionDate: inspectionDate
        ? Timestamp.fromDate(new Date(inspectionDate))
        : null,
      updatedAt: new Date(),
    });
    setSaving(false);
  };

  const createInspectionReport = async () => {
    const docRef = await addDoc(collection(db, "inspectionReports"), {
      leadId: id,
      status: "draft",
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
      sections: {
        overview: "",
        membrane: "",
        flashing: "",
        drainage: "",
        recommendations: ""
      }
    });

    navigate(`/admin/reports/${docRef.id}`);
  };

  if (!lead || checkingReport) return null;

  return (
    <div className="admin-page">
      <AdminNav />
      <button onClick={() => navigate(-1)}>← Back to Leads</button>

      <h1>{lead.company || "Unnamed Company"}</h1>
      <p><strong>Name:</strong> {lead.name}</p>
      <p><strong>Email:</strong> {lead.email}</p>
      <p><strong>Phone:</strong> {lead.phone}</p>
      <p><strong>Address:</strong> {lead.address}</p>

      <hr />

      <label>Status</label>
      <select
        value={status}
        onChange={(e) => setStatus(e.target.value)}
      >
        <option value="new">New</option>
        <option value="contacted">Contacted</option>
        <option value="inspection_scheduled">Inspection Scheduled</option>
        <option value="closed">Closed</option>
      </select>

      <label>Inspection Date</label>
      <input
        type="date"
        value={inspectionDate}
        onChange={(e) => {
          setInspectionDate(e.target.value);
          if (status === "contacted") {
            setStatus("inspection_scheduled");
          }
        }}
      />

      <label>Inspection Report</label>
      {reportId ? (
        <button
          className="btn btn-secondary"
          onClick={() => navigate(`/admin/reports/${reportId}`)}
        >
          View / Edit Inspection Report
        </button>
      ) : (
        <button
          className="btn btn-primary"
          onClick={createInspectionReport}
        >
          Create Inspection Report
        </button>
      )}

      <label>Internal Notes</label>
      <textarea
        rows={6}
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        placeholder="Internal notes, follow-ups, inspection details..."
      />

      <button onClick={saveChanges} disabled={saving}>
        {saving ? "Saving..." : "Save Changes"}
      </button>
    </div>
  );
}
